// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * PortElementsList — solo lo específico de esta página.
 *
 * Aquí había 554 líneas que repetían lo mismo que el resto de listados
 * (contenedor, cabecera, barra de filtros, tabla, badges, botones, acciones,
 * diálogos...) cada una con su prefijo \`pel-\`, y encima una familia entera de
 * reglas \`pel-form-*\` y \`pel-preset-*\` que ya no usa nadie. Todo eso se ha
 * borrado: lo aporta \`styles/lists.css\`, que es el sistema común de listados y
 * se carga una sola vez para toda la aplicación.
 *
 * Lo que queda es lo que de verdad es de esta página: la barra de uso de
 * puertos y el botón que los abre.
 */

/* ── Barra de uso de puertos (columna "Puertos") ─────────────────────────── */

.pel-port-count {
  font-weight: var(--fw-bold);
  color: var(--text-primary);
}

.pel-port-bar-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pel-port-bar {
  flex: 1 1;
  min-width: 60px;
  height: 6px;
  border-radius: var(--radius-sm);
  background: var(--bg-input);
  overflow: hidden;
}

.pel-port-bar-fill {
  height: 100%;
  border-radius: var(--radius-sm);
  transition: width 0.3s ease;
}

.pel-port-bar-label {
  font-size: 12px;
  color: var(--text-muted);
  white-space: nowrap;
}

/* ── Botón de puertos: es un botón de acción con texto, no de icono ─────── */

/* Ojo con la especificidad: \`styles/lists.css\` define el aspecto de
   \`.pel-action-btn\` y se carga DESPUÉS que este fichero (los CSS de componente
   entran antes), así que a igual especificidad gana él y este botón se quedaba
   con el color de texto secundario. Con \`button.\` delante (0,1,1) vuelve a
   mandar el componente. */
button.pel-action-btn--ports {
  width: auto;
  padding: 0 8px;
  color: var(--accent);
  font-size: 0.75rem;
  font-weight: var(--fw-semibold);
}

/* Puerto sin ubicar: en gris y en cursiva, para no confundirlo con uno real */
.pel-unplaced {
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/PortElementsList.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF,+EAA+E;;AAE/E;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;;;;0BAI0B;AAC1B;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;AACpB","sourcesContent":["/**\r\n * PortElementsList — solo lo específico de esta página.\r\n *\r\n * Aquí había 554 líneas que repetían lo mismo que el resto de listados\r\n * (contenedor, cabecera, barra de filtros, tabla, badges, botones, acciones,\r\n * diálogos...) cada una con su prefijo `pel-`, y encima una familia entera de\r\n * reglas `pel-form-*` y `pel-preset-*` que ya no usa nadie. Todo eso se ha\r\n * borrado: lo aporta `styles/lists.css`, que es el sistema común de listados y\r\n * se carga una sola vez para toda la aplicación.\r\n *\r\n * Lo que queda es lo que de verdad es de esta página: la barra de uso de\r\n * puertos y el botón que los abre.\r\n */\r\n\r\n/* ── Barra de uso de puertos (columna \"Puertos\") ─────────────────────────── */\r\n\r\n.pel-port-count {\r\n  font-weight: var(--fw-bold);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pel-port-bar-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.pel-port-bar {\r\n  flex: 1;\r\n  min-width: 60px;\r\n  height: 6px;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--bg-input);\r\n  overflow: hidden;\r\n}\r\n\r\n.pel-port-bar-fill {\r\n  height: 100%;\r\n  border-radius: var(--radius-sm);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.pel-port-bar-label {\r\n  font-size: 12px;\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Botón de puertos: es un botón de acción con texto, no de icono ─────── */\r\n\r\n/* Ojo con la especificidad: `styles/lists.css` define el aspecto de\r\n   `.pel-action-btn` y se carga DESPUÉS que este fichero (los CSS de componente\r\n   entran antes), así que a igual especificidad gana él y este botón se quedaba\r\n   con el color de texto secundario. Con `button.` delante (0,1,1) vuelve a\r\n   mandar el componente. */\r\nbutton.pel-action-btn--ports {\r\n  width: auto;\r\n  padding: 0 8px;\r\n  color: var(--accent);\r\n  font-size: 0.75rem;\r\n  font-weight: var(--fw-semibold);\r\n}\r\n\r\n/* Puerto sin ubicar: en gris y en cursiva, para no confundirlo con uno real */\r\n.pel-unplaced {\r\n  font-style: italic;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
